module.exports = __webpack_public_path__ + "static/wwf-onesource-horizontal-logo-reverse-rgb-944309a0118a1aa62f0a1d1fd7fd3162.svg";